module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pro"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Chicago"), _c('br'), _vm._v("12 January 1972")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("The wind sulked around Hampton Lane cemetery like a child lamenting the loss of a favorite toy. It stirred the crisp autumn leaves lining the many cobbled paths, but did little more than tow them along slowly, like condemned souls being dragged to the afterlife.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Standing among the rolling fields of dead in a sea of granite and marble tombstones, Fletcher Carson trudged toward the foot of a tree where his life lay buried under two stark stone crosses. His wife, Abigail, had been such a positive person that she had seldom discussed death, a reluctance underlined by the loss of her parents barely a year ago. Only during the drawing up of their wills did it emerge that she wished to be interred under the shade of a maple tree with only a simple cross to mark her final resting place. Her epitaph was every word as humble as she was. It read:")]), _vm._v(" "), _c('p', {
    staticClass: "epitaph"
  }, [_vm._v("H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ERE RESTS")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BIGAIL")]), _vm._v(" C"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARSON, LOVING WIFE AND MOTHER.")])]), _vm._v(" "), _c('p', {
    staticClass: "epitaph"
  }, [_vm._v("M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AY HER LIGHT NEVER FADE FROM OUR HEARTS.")])]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("Kelly’s cross was half the size of her mother’s. It carried only her name and the dates of her short life. When it came down to it, and despite being a writer for most of his working life, Fletcher hadn’t been able to commission a message. The right words, he was certain, did not exist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fletcher.” A voice drifted toward him. “I thought I’d find you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fletcher immediately recognized the broad Southern drawl. It was Marvin Samuels, his editor and possibly only remaining friend in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You look good,” Marvin remarked, but the inflection in his voice suggested otherwise. At just under six feet, Fletcher Carson was by no means a particularly tall man, but there was a stoop in his posture now that belied his true height. He was blessed with smooth olive skin, thick black hair, and hazel eyes like large nuggets of carved oak. A distinctive cleftlike scar in the middle of his chin did little to detract from his good looks. At twenty-nine, he was in the prime of his life, but the burden of the recent months weighed heavily on him. His athletic build remained, but his face carried the expression of a man who had wandered into a dark labyrinth and long since abandoned hope of ever finding his way out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I read somewhere that the dead can hear you,” Fletcher said, staring at the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They say that if someone they really loved visits their grave, they can hear that person’s thoughts. It can be raining or blowing a gale around the cemetery, but just around their grave, everything becomes still. That’s when they’re listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I hope it’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fletcher slipped his hands into his pockets. “Why have you come here, Marvin?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why do you ask questions you know the answers to?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’ve been through this; there’s nothing left to discuss. I’m leaving tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You know your mother’s going out of her mind with worry? I can’t keep making excuses for you. When are you going to return her calls?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We keep missing each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Like hell you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s complicated, Marvin. Please stay out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marvin folded his arms and looked up at the sky. “Sure. I’ll just stand around and watch while you try to get yourself killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m asking you to respect my decision.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you think this is what your girls would’ve wanted?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fletcher snapped his head around, anger curling up a corner of his mouth. “You’re in no position to ask that. Do you have any idea what the last few months have been like?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Of course not, but going off to fight in Vietnam isn’t the answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What if it were Cathy or Cynthia? What would you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d try to find a way to get over their passing and carry on with my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Really?”")]), _vm._v(" Fletcher said, swallowing hard, and then pointing to his daughter’s grave. “Kelly was barely seven, Marvin. How do you get over that? If you know, please enlighten me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fletcher—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell me something,” he went on, his voice faltering, “do you know where the line is?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The line?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where you end … and your family begins.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“C’mon, don’t do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll tell you. There is no line. I understand that now. You’re one entity, and when a part of you is cut away, the rest of you slowly bleeds out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Jesus, Fletcher.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Our soldiers are being massacred in Vietnam. Most of them are still kids. They’ve got their whole lives ahead of them. It makes sense that people like me enlist.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“People like you,” Marvin repeated. “You mean people who want to die. You need help, Fletcher, you need to speak to a professional.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A shrink? Will that bring back my girls?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It might help you to learn to cope without them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s just it,” Fletcher said, shaking his head. “I don’t want to cope without them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marvin tried to reply, but could draw on nothing meaningful to say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I appreciate you coming and all that you’ve done for me, but I think you should leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just let me—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Please,” Fletcher whispered. “Just go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marvin began to walk away, then stopped. “Do you remember that piece you did on suicide when you were still covering hospitals? At the end, you wrote that if only the sufferers had been able to see past the moment of their pain, they could claw their way back to life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What I didn’t realize at the time,” Fletcher replied, his voice thin, “is that you can never truly understand things that haven’t happened to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marvin stared up at the sky. “I’ve stood by you through this whole goddamn nightmare. From the moment the plane went down to the day you were discharged from the hospital. If you leave tomorrow, then I’ve just been wasting my time.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sorry, Marvin, but this isn’t about you. I’ve made my decision.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fine, but know that this is the last thing your girls would’ve wanted for you. You’re making a terrible mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe … but it’s mine to make.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marvin turned away, shaking his head. “You’re heading into a nightmare. It’s hell over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fletcher nodded slowly and pictured his girls beneath his feet. “It’s hell everywhere,” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Marvin was gone, Fletcher knelt down between the two graves. He reached into his pocket and pulled out a silver frame Abigail had kept on her bedside table. It held one of her favorite photos of the three of them, sitting on a large boulder in Yellowstone Park. He gently placed it down on the plot of fresh grass covering her grave. From another pocket, he withdrew a small wooden box, which he rested against the foot of Kelly’s cross. In it was a crystal sculpture of the dog he had promised to buy her. She had died three days before her seventh birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was the present she would never have.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6631d670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0